import mixpanel from 'mixpanel-browser';

import { AuthErrorType } from '@src/app/contexts/Auth';

export interface AuthErrorLink {
    text: string;
    href: string;
    trackEvent?: string;
}

export interface AuthError {
    message: string;
    link?: AuthErrorLink;
}

export const handleAuthResult = (
    result: any,
    values: { email: string },
    setErrors: (error: { error: string | AuthError }) => void,
    onSuccess: () => void,
) => {
    if (result.success) {
        return onSuccess();
    }
    if (result.errorType === AuthErrorType.USER_EXISTS) {
        const redirectTo = `../login?email=${encodeURIComponent(
            values.email || '',
        )}&applicationId=${encodeURIComponent(result.applicationId || '')}`;

        mixpanel.track('shown_validation_login_fact_find');

        return setErrors({
            error: {
                message: 'An account with this email already exists. Please ',
                link: {
                    text: 'log in here',
                    href: redirectTo,
                    trackEvent: 'tapped_validation_login_fact_find',
                },
            },
        });
    }

    setErrors({ error: result.message });
};
